import { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { Button, Card, CardBody, Col, Container, Row } from "reactstrap";
import TinyEditor from "../../components/TinyEditor/TinyEditor";
import { tinyEditorTypes } from "../../enums/tinyEditorTypes";
import { connect } from "react-redux";
import { saveSnippet } from "../../store/actions";
import { stringToBase64 } from "../../helpers/base64_helper";

const TinyEditorTeste = ({ saveSnippetRequest }) => {
  const [initialValue1, setInitialValue1] = useState("");
  const [editorValue1, setEditorValue1] = useState("");
  const [initialValue2, setInitialValue2] = useState("");
  const [editorValue2, setEditorValue2] = useState("");
  const [initialValue3, setInitialValue3] = useState("");
  const [editorValue3, setEditorValue3] = useState("");
  const [initialValue4, setInitialValue4] = useState("");
  const [editorValue4, setEditorValue4] = useState("");
  const [initialValue5, setInitialValue5] = useState("");
  const [editorValue5, setEditorValue5] = useState("");
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    setTimeout(() => {
      setInitialValue1(
        "<head><style>p{ color: red }</style></head><p>Editor initial value</p>"
      );
      setInitialValue2(`<ul>
<li>Editor list 1</li>
<li>Editor list 2</li>
<li>Editor list 3</li>
</ul>
<ol>
<li>Editor list 1</li>
<li>Editor list 2</li>
<li>Editor list 3
<ol>
<li>Editor list 1</li>
<li>Editor list 2</li>
</ol>
</li>
</ol>`);
      setInitialValue3(`<table style="border-collapse: collapse; width: 100%;" border="1"><colgroup><col style="width: 25%;"><col style="width: 25%;"><col style="width: 25%;"><col style="width: 25%;"></colgroup>
<tbody>
<tr>
<td>Editor</td>
<td>Initial</td>
<td>Table</td>
<td>Value</td>
</tr>
<tr>
<td>123</td>
<td>456</td>
<td>789</td>
<td>101112</td>
</tr>
</tbody>
</table>`);
      setInitialValue4(
        `<p><img src="https://placehold.co/600x400" alt="" width="600" height="400"></p>`
      );
      setInitialValue5(`<p>Editor initial value</p>
  <ul>
<li>Editor list 1</li>
<li>Editor list 2</li>
<li>Editor list 3</li>
</ul>
<ol>
<li>Editor list 1</li>
<li>Editor list 2</li>
<li>Editor list 3
<ol>
<li>Editor list 1</li>
<li>Editor list 2</li>
</ol>
</li>
</ol>
  <table style="border-collapse: collapse; width: 100%;" border="1"><colgroup><col style="width: 25%;"><col style="width: 25%;"><col style="width: 25%;"><col style="width: 25%;"></colgroup>
<tbody>
<tr>
<td>Editor</td>
<td>Initial</td>
<td>Table</td>
<td>Value</td>
</tr>
<tr>
<td>123</td>
<td>456</td>
<td>789</td>
<td>101112</td>
</tr>
</tbody>
</table>
<p><img src="https://placehold.co/600x400" alt="" width="600" height="400"></p>`);
      setLoading(false);
    }, 2500);
  }, []);

  return (
    <>
      <div className="page-content">
        <Helmet>
          <title>Teste Tiny Editor</title>
        </Helmet>
        <Container fluid>
          <Row>
            <Card>
              <CardBody>
                <Row>
                  <Col xs={12}>
                    <TinyEditor
                      initialValue={initialValue1}
                      handleEditorChange={(content) => {
                        setEditorValue1(content);
                      }}
                      loading={loading}
                      type={tinyEditorTypes.TEXT}
                      contentStyle={"p { color: red }"}
                    />
                  </Col>
                  <Col xs={12} className="my-3">
                    <Button
                      color="primary"
                      onClick={() => {
                        alert(stringToBase64(editorValue1));
                      }}
                    >
                      Alert content
                    </Button>
                  </Col>
                  <Col xs={12}>
                    <TinyEditor
                      initialValue={initialValue2}
                      handleEditorChange={(content) => {
                        setEditorValue2(content);
                      }}
                      loading={loading}
                      type={tinyEditorTypes.LIST}
                    />
                  </Col>
                  <Col xs={12} className="my-3">
                    <Button
                      color="primary"
                      onClick={() => {
                        alert(stringToBase64(editorValue2));
                      }}
                    >
                      Alert content
                    </Button>
                  </Col>
                  <Col xs={12}>
                    <TinyEditor
                      initialValue={initialValue3}
                      handleEditorChange={(content) => {
                        setEditorValue3(content);
                      }}
                      loading={loading}
                      type={tinyEditorTypes.TABLE}
                    />
                  </Col>
                  <Col xs={12} className="my-3">
                    <Button
                      color="primary"
                      onClick={() => {
                        alert(stringToBase64(editorValue3));
                      }}
                    >
                      Alert content
                    </Button>
                  </Col>
                  <Col xs={12}>
                    <TinyEditor
                      initialValue={initialValue4}
                      handleEditorChange={(content) => {
                        setEditorValue4(content);
                      }}
                      loading={loading}
                      type={tinyEditorTypes.IMAGE}
                    />
                  </Col>
                  <Col xs={12} className="my-3">
                    <Button
                      color="primary"
                      onClick={() => {
                        alert(stringToBase64(editorValue4));
                      }}
                    >
                      Alert content
                    </Button>
                  </Col>
                  <Col xs={12}>
                    <TinyEditor
                      initialValue={initialValue5}
                      handleEditorChange={(content) => {
                        setEditorValue5(content);
                      }}
                      loading={loading}
                      type={tinyEditorTypes.HTML}
                    />
                  </Col>
                  <Col xs={12} className="my-3">
                    <Button
                      color="primary"
                      onClick={() => {
                        alert(stringToBase64(editorValue5));
                      }}
                    >
                      Alert content
                    </Button>
                  </Col>
                  <Col xs={12} className="my-3">
                    <Button
                      color="primary"
                      onClick={() => {
                        saveSnippetRequest({
                          body: {
                            active: true,
                            title: "Teste Integração Editor",
                            idRegion: 10020,
                            idBusiness: 10066,
                            description:
                              "Teste Inicial Para Provar Integração Do Editor",
                            deleted: false,
                            content: [
                              {
                                order: 0,
                                type: "Text",
                                content: editorValue1,
                              },
                              {
                                order: 1,
                                type: "List",
                                content: editorValue2,
                              },
                              {
                                order: 2,
                                type: "Table",
                                content: editorValue3,
                              },
                              {
                                order: 3,
                                type: "Image",
                                content: editorValue4,
                              },
                              {
                                order: 4,
                                type: "Code",
                                content: editorValue5,
                              },
                            ],
                          },
                          type: "POST",
                        });
                      }}
                    >
                      Save content
                    </Button>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Row>
        </Container>
      </div>
    </>
  );
};

export const mapStateToProps = null;

const mapDispatchToProps = {
  saveSnippetRequest: saveSnippet.request,
};

export default connect(mapStateToProps, mapDispatchToProps)(TinyEditorTeste);
